export default "# Logo 徽标\r\n\r\nGLP 通用徽标。\r\n\r\nGLP后台系统统一系统徽标，用于菜单栏logo。";